<template>
  <div class="mask addExtraResource" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <p class="title">
          {{`添加设备`}}
        </p>
        <img src="../assets/img/resources/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="number">
        <span class="required">*</span>
        <div class="inputer">
          <input type="text" :placeholder="`请输入设备名称`" v-model="title">
        </div>
      </div>
      <div class="detail">
        <div class="item">
          <span class="required">*</span>
          <span class="name">编号</span>
          <span class="input">
            <input type="text" v-model="idstring">
          </span>
        </div>
        <div class="item">
          <span class="required">*</span>
          <span class="name">类型</span>
          <span class="input select">
            <select v-model="classInfo.id">
              <option :value="c.type_id" v-for="c in classes" :key="c.type_id">{{c.title}}</option>
            </select>
            <img src="../assets/img/resources/down.svg" alt="down" class="down">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">品牌</span>
          <span class="input">
            <input type="text" v-model="brand">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">型号</span>
          <span class="input">
            <input type="text" v-model="device_model">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">序列号</span>
          <span class="input">
            <input type="text" v-model="serial_num">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">采购日期</span>
          <span class="input date">
            <el-date-picker
              v-model="buy_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </span>
        </div>
        <div class="item" v-if="type === 1">
          <span class="required">*</span>
          <span class="name">姓名</span>
          <span class="input">
            <input type="text" v-model="people.name">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">保管人</span>
          <span class="input">
            <input type="text" v-model="keeper">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">存放位置</span>
          <span class="input">
            <input type="text" v-model="location">
          </span>
        </div>
        <!-- <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">单价</span>
          <span class="input">
            <input type="text" v-model="device.price">
          </span>
        </div>
        <div class="item" v-if="type === 2">
          <span class="required"></span>
          <span class="name">报价单位</span>
          <span class="input">
            <input type="text" v-model="device.seller">
          </span>
        </div> -->
        <div class="item" v-if="type === 1">
          <span class="required"></span>
          <span class="name">手机</span>
          <span class="input">
            <input type="text" v-model="people.tel">
          </span>
        </div>
        <!-- <div class="item long" v-if="type === 1 && classInfo.id == '6'"> -->
        <div class="item long" v-if="type === 1 && classInfo.id == '6'">
          <span class="required"></span>
          <span class="name">配置车辆</span>
          <span class="input">
            <!-- <input type="text" v-model="people.bus"> -->
            <select class="" v-model="people.bus" @change="changeBus">
              <option :value="0" disabled selected>请选择</option>
              <option :value="b.id" v-for="b in buses" :key="b.id">{{b.title}}</option>
            </select>
            <span class="stxt">选择</span>
          </span>
          <span class="notice" v-if="selectedBus.isbusy">
            <img src="@assets/img/interview/alert.svg" alt="alert">
            <span>该车已有绑定人员</span>
          </span>
        </div>
      </div>
      <div class="remark">
        <p>其他附件</p>
        <textarea v-model="other_comment" maxlength="60">
        </textarea>
        <span class="count">{{`${other_comment.length}/60`}}</span>
      </div>
      <div class="remark">
        <p>备注</p>
        <textarea v-model="remark" maxlength="60">
        </textarea>
        <span class="count">{{`${remark.length}/60`}}</span>
      </div>
      <div class="btn" @click="addResource()">
        保存
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import DatePicker from 'vue2-datepicker'
export default {
  name: 'addResource',
  components: {
    DatePicker
  },
  data() {
    return {
      show: false,
      type: 1,
      title: '',
      idstring: '',
      brand: '',
      device_model: '',
      serial_num: '',
      buy_time: '',
      keeper: '',
      location: '',
      other_comment: '',
      remark: '',
      types: [  // 资源类型
        {
          t: 1,
          name: '人员'
        },
        {
          t: 2,
          name: '设备'
        }
      ],
      info: {  // 基础信息
        number: '',
        remark: ''
      },
      device: {  // 设备信息
        name: '',
        locate: '',
        price: '',
        seller: ''
      },
      people: {  // 人员信息
        name: '',
        tel: '',
        bus: '0'
      },
      bases: [],  // 分类数据
      classes: [],  // 类型数据
      baseInfo: {  // 分类已选信息
        id: '',
        title: ''
      },
      classInfo: {  // 类型已选信息
        id: '',
        title: ''
      },
      buses: [],  // 弹窗为‘人员’且类型是‘司机’时，供选车辆数据
      selectedBus: {  // buses中已选车辆数据
        id: '',
        isbusy: false
      }
    }
  },
  computed: {
    baseId() {
      // 将baseInfo中的id抽出来watch，防止为baseInfo赋值导致变化
      return this.baseInfo.id
    }
  },
  watch: {
    baseId: {
      deep: true,
      handler: function(n, o) {
        this.changeClasses(n)
      }
    },
    classInfo: {
      deep: true,
      handler: function(n, o) {
        // this.getBuses()
        this.classInfo.id = n.id
      }
    }
  },
  methods: {
    getClass() {
      common.myFetch(apis.Type_list, {type: 1})
      .then((data) => {
        this.classes = data.list
        this.$set(this.classInfo, 'id', this.classes[0].type_id)
        console.log(data)
      })
    },
    changeBus(e) {
      // 切换人员配置采访车
      const id = e.target.value
      this.buses.forEach((i) => {
        if (i.id == id) {
          this.$set(this.selectedBus, 'id', i.id)
          this.$set(this.selectedBus, 'isbusy', !!i.person_id)
        }
      })
    },
    getBuses() {
      // 获取采访车列表
      common.myFetch(apis.Res_bus_list, {})
      .then((data) => {
        this.buses = data.list
      })
    },
    changeClasses(s) {
      // 切换分类，分类和类型联动，默认选择类型第一项
      this.bases.forEach((i) => {
        if (s === i.id) {
          this.classes = i.list
          this.$set(this.classInfo, 'id', this.classes[0].id)
        }
      })
    },
    resetData() {
      this.info = {
        number: '',
        remark: ''
      }
      this.device = {
        name: '',
        locate: '',
        price: '',
        seller: ''
      }
      this.people = {
        name: '',
        tel: '',
        bus: '0'
      }

      this.bases = []
      this.classes = []
      this.buses = []
      this.baseInfo = {
        id: '',
        title: ''
      }
      this.classInfo = {
        id: '',
        title: ''
      }
      this.selectedBus = {
        id: '',
        isbusy: false
      }
    },
    open(t) {
      // 打开弹窗方法
      this.resetData()
      this.type = t
      // this.watchType()
      // this.fill()
      this.getClass()
      this.show = true
    },
    close() {
      // 关闭方法
      this.$emit('reload')
      this.show = false
    },
    watchType() {
      // 根据类型匹配title
      const t = this.type
      this.types.forEach((i) => {
        if (i.t === t) {
          this.title = i.name
        }
      })
    },
    async addResource() {
      // 根据类型提交数据
      let done = false

      if (this.type === 1) {
        done = await this.addPeople()
      } else {
        done = await this.addDevice()
      }
      if (done) {
        this.close()
      }
    },
    addPeople() {
      // 提交添加人员数据
      const idstring = this.info.number
      const remark = this.info.remark
      const class_id = this.baseInfo.id
      const class_title = this.bases.map(i => {return i.id === class_id ? i.title : ''}).join('')
      const type_id = this.classInfo.id
      const type_title = this.classes.map(i => {return i.id === type_id ? i.title : ''}).join('')
      const title = this.people.name
      const phone = this.people.tel
      const bus = this.people.bus

      const info = {
        idstring: idstring,
        class_id: class_id,
        class_title: class_title,
        type_id: type_id,
        type_title: type_title,
        remark: remark,
        title: title,
        phone: phone,
        bus: bus
      }

      return common.myFetch(apis.Res_people_add, info)
      .then((data) => {
        if (data) {
          this.$toast(data)

          return true
        }

        return false
      })
    },
    addDevice() {
      // 提交添加设备数据
      const remark = this.remark
      const other_comment = this.other_comment
      const title = this.title
      const idstring = this.idstring
      const type_id = this.classInfo.id
      const brand = this.brand
      const device_model = this.device_model
      const serial_num = this.serial_num
      const buy_time = this.buy_time
      const keeper = this.keeper
      const location = this.location
      

      const info = {
        id: this.id || '',
        title: title,
        idstring: idstring,
        type_id: type_id,
        brand: brand,
        device_model: device_model,
        serial_num: serial_num,
        buy_time: buy_time,
        keeper: keeper,
        location: location,
        other_comment: other_comment,
        remark: remark
      }

      return common.myFetch(apis.Edit_expand, info, 'post')
      .then((data) => {
        if (data) {
          this.$toast(data)

          this.remark = ''
          this.other_comment = ''
          this.title = ''
          this.idstring = ''
          this.classInfo.id = this.classes[0].type_id
          this.brand = ''
          this.device_model = ''
          this.serial_num = ''
          this.buy_time = ''
          this.keeper = ''
          this.location = ''

          return true
        }

        return false
      })
    },
    fill() {
      // 获取填充数据
      const info = {
        page_type: this.type
      }

      common.myFetch(apis.Res_resource_add_fill, info)
      .then((data) => {
        this.bases = data
        this.$set(this.baseInfo, 'id', this.bases[0].id)
        this.classes = this.bases[0].list
        this.$set(this.classInfo, 'id', this.classes[0].id)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1200;
  background-color: rgba(0,0,0,0.70);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 680px;
    height: 680px;
    padding: 20px 30px;
    .headline {
      height: 34px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .title {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        cursor: pointer;
      }
    }
    .required {
      color: @red;
      width: 10px;
      font-size: 24px;
      font-family: Helvetica, sans-serif;
      margin-right: 10px;
    }
    .number {
      width: 100%;
      display: flex;
      align-items: center;
    }
    .inputer {
      flex: 1;
      height: 40px;
      border-radius: 4px;
      background-color: rgba(185, 195, 195, 0.2);
      display: flex;
      padding: 10px 20px;
      margin-bottom: 13px;
      input {
        background-color: transparent;
        flex: 1;
        font-size: 14px;
        color: @dark;
        &::placeholder {
          color: @dateColor;
          font-size: 14px;
        }
      }
    }
    .detail {
      padding-bottom: 7px;
      border-bottom: 1px solid #dcdcdc;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .item {
        width: 50%;
        margin: 13px 0;
        height: 30px;
        display: flex;
        align-items: center;
        .name {
          width: 52px;
          font-size: 14px;
          color: @sub;
          text-align-last: justify;
          margin-right: 30px;
          word-break: keep-all;
        }
        .input {
          box-sizing: border-box;
          width: 180px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid #dcdcdc;
          padding-left: 38px;
          font-size: 14px;
          color: @dark;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          overflow: hidden;

          &.select {
            position: relative;
            padding: 0;
          }

          &.date {
            position: relative;
            padding: 0;
          }
          
          select {
            background: transparent;
            font-size: 14px;
            height: 100%;
            flex: 1;
            border: none;
            outline: none;
            padding: 0 0px 0 38px;
            box-sizing: border-box;
          }
          input {
            font-size: 14px;
            height: 100%;
            flex-grow: 1;
            flex-shrink: 1;
            box-sizing: border-box;
            background-color: transparent;
          }
          .down {
            position: absolute;
            right: 12px;
            // margin: 0 10px;
          }
        }
      }
      .item:nth-child(2n) {
        justify-content: flex-end;
      }
      .long {
        width: 100% !important;
        justify-content: flex-start !important;
        .stxt {
          width: 30px;
          flex-shrink: 0;
          font-size: 14px;
          color: @green;
          cursor: pointer;
        }
        input {
          max-width: 100px;
        }
        .notice {
          display: flex;
          font-size: 14px;
          color: @sub;
          img {
            margin: 0 6px 0 10px;
          }
        }
      }
    }
    .remark {
      display: flex;
      flex-direction: column;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #dcdcdc;
      margin: 20px 0;
      padding: 14px 20px 28px;
      position: relative;
      p {
        font-size: 14px;
        color: #B9C3C3;
        margin-bottom: 6px;
      }
      textarea {
        width: 100%;
        height: 100%;
        background-color: transparent;
        resize: none;
        font-size: 16px;
        color: @dark;
        &::placeholder {
          color: @dateColor;
        }
      }
      .count {
        font-size: 16px;
        color: @dateColor;
        bottom: 8px;
        right: 18px;
        position: absolute;
      }
    }
    .btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 100px;
      background-color: @green;
      color: #fff;
      font-size: 14px;
      margin: 0 auto;
      cursor: pointer;

      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
  }
}
</style>
<style lang="less">
.addExtraResource {

  .el-date-editor {
      width: 100%;
      height: 100%;

      .el-icon-date {
        line-height: 28px;
      }

      .el-input__icon {
        line-height: 28px;
      }

      input {
        width: 100%;
        height: 100%;
        border: none;
        background: transparent;
      }
    }
}
</style>